import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
import { resolveMediaUrl } from '../ui/resolveMediaUrl';
import { MediaSlider } from '../ui/media-slider';
import type { RoomCarouselItem } from './rooms-carousel-block';

interface RoomDetailSheetProps {
  room: RoomCarouselItem | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RoomDetailSheet({ room, open, onOpenChange }: RoomDetailSheetProps) {
  // Prefer the CMS `images` gallery; fall back to the single cover `image` used by the carousel card.
  const images = room?.item.images?.length ? room.item.images : room?.item.image ? [room.item.image] : [];

  return (
    <Drawer open={open} onOpenChange={onOpenChange} showSwipeHandle>
      <DrawerContent className="max-h-[85vh]">
        <div data-base-ui-swipe-ignore className="flex flex-1 flex-col gap-6 overflow-y-auto pb-10">
          <div className="flex flex-col gap-6 pt-6">
            {room?.item.title && <DrawerTitle className="px-4">{room.item.title}</DrawerTitle>}

            {images.length > 0 && (
              <div className="flex flex-col gap-2 pl-4">
                <MediaSlider
                  items={images}
                  gapClassName="gap-2"
                  gapPx={8}
                  fallbackRatio={0.62}
                  renderItem={(img, i, cardProps) => (
                    <div
                      key={i}
                      className="h-[240px] w-[62vw] shrink-0 snap-start overflow-hidden"
                      {...cardProps}
                    >
                      <img
                        src={resolveMediaUrl(img?.url)}
                        alt={room?.item.title ?? ''}
                        className="size-full object-cover"
                      />
                    </div>
                  )}
                />
              </div>
            )}

            {/* whitespace-pre-line: description is plain CMS text (no RTE), so line breaks
              only render if preserved explicitly. */}
            {room?.item.description && (
              <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 px-4 text-[14px] leading-normal tracking-[0.25px] whitespace-pre-line">
                {room.item.description}
              </p>
            )}
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
